import React, { useEffect, useState, useRef } from 'react';
import Paper from '@mui/material/Paper';
import { STORES_HEADERS, STORES_HEADERS_ACCESS, STORES_SEARCH_PLACEHOLDER, STORES_TABLE_NAME, STORES_TABLE_SUBTITLE, STORES_TABLE_SUBTITLE_REQUEST } from '../constants/merchantsConstants';
import { useDispatch, useSelector } from 'react-redux';
import { brandIDSelectedSaga, merchantAccessTokenSaga, selectedBrandDetailsSaga, storeConnectionSaga, storeConnectionStatusSaga, storeListSaga } from '../redux/saga/merchantServiceSelectors';
import { Grid, Typography, Breadcrumbs, Link, Snackbar } from '@mui/material';
import MuiAlert from '@mui/material/Alert';
import { handleSortingInTable } from '../shared/utils/format.helpers';
import { deleteStoreConnection, getStoreConnection, merchantGetStoresDetailsOfBrand, postStoreConnection, updateLoadingStatus } from '../redux/actions/merchantAction';
import { useNavigate, Link as RouterLink } from 'react-router-dom';
import './otter.scss';
import StoresDetailsCard from './stores.details';
import DataTable from '../shared/tables/DataTable';
import CustomPagination from '../shared/pagination/CustomPagination';
import CustomPopOver from '../shared/pop-over/custom.pop-over';
import { ACTIVATE, CONTINUE, DEACTIVATE } from '../constants/buttonConstants';
import { ACTIVATION_POPOVER, REDIRECT_CONNECT_POPOVER } from '../constants/landingConstant';
import { accessTokenSaga } from '../redux/saga/loginServiceSelector';
import OtterBrands from './otter.brands';
import { apiLoadingStatusSaga } from '../redux/saga/merchantServiceSelectors';

const  OtterStores = ({ setContent }) => {

	const navigate = useNavigate();
	const dispatch = useDispatch();
	let storeID = '';

	const storeListData = useSelector(storeListSaga);
	const accessToken = useSelector(merchantAccessTokenSaga);
	const brandID = useSelector(brandIDSelectedSaga);
	const storeStatus = useSelector(storeConnectionStatusSaga);
	const storeConnection = useSelector(storeConnectionSaga);
	const accessTokenValue = useSelector(accessTokenSaga);
	const selectedBrand = useSelector(selectedBrandDetailsSaga);
	const apiLoadingStatus = useSelector(apiLoadingStatusSaga);
	const [openDetailsPanel, setOpenDetailsPanel] = useState(false);
	const [popOverTitle, setpopOverTitle] = useState();
	const [merchantAccountView, setmerchantAccountView] = useState();
	const [primaryButtonText, setprimaryButtonText] = useState('');
	const [primaryButtonColor, setPrimaryButtonColor] = useState('');
	const [openConnection, setOpenConnection] = useState(false);
	const [selectedValue, setSelectedValue] = useState('');
	const [selectedStoreName, setSelectedStoreName] = useState('');
	const [listHeight, setListHeight] = useState('100px');
	const [listTitle, setlistTitle] = useState('');
	const [storeHeader, setStoreHeader] = useState([]);
	const [intergrationDoesNotTokenExists, setIntergrationDoesNotTokenExists] = useState(true);
	const [currentAction, setCurrentAction] = useState(null);
	const [openSnackbar, setOpenSnackbar] = useState(false);
	const [snackbarMessage, setSnackbarMessage] = useState('');
	const [snackbarSeverity, setSnackbarSeverity] = useState('success');
	const [storesTableSubtitle, setStoresTableSubtitle] = useState(STORES_TABLE_SUBTITLE)
	const [snackbarKey, setSnackbarKey] = useState(0);
	const prevApiLoadingStatus = useRef(apiLoadingStatus);
	const [currentPage, setCurrentPage] = useState(0);
	const [rowsPerPage, setRowsPerPage] = useState(10);
	const [wholeStoreList, setWholeStoreList] = useState([]);
	const [totalPages, setTotalPages] = useState(0);
	const [sortConfig, setSortConfig] = useState({ key: 'id', direction: 'Ascending' });
	const [searchTerm, setSearchTerm] = useState('');
	const integrationToken = sessionStorage.getItem('access_token_otter');

	const Alert = React.forwardRef(function Alert(props, ref) {
		return <MuiAlert elevation={6} ref={ref} variant='filled' {...props} />;
	});

	const handleSnackbarClose = (event, reason) => {
		if (reason === 'clickaway') {
			return;
		}
		setOpenSnackbar(false);
	};

	const showSnackbar = (message, severity) => {
		setSnackbarMessage(message);
		setSnackbarSeverity(severity);
		setSnackbarKey(prevKey => prevKey + 1);
		setOpenSnackbar(true);
	};

	useEffect(() => {
		if (prevApiLoadingStatus.current === 'De-Activating Store....Please wait!' && apiLoadingStatus === '') {
			setSnackbarSeverity('error');
			setSnackbarMessage(`${selectedStoreName} has been successfully deactivated.`);
			setOpenSnackbar(false);
		} else if (prevApiLoadingStatus.current === 'Activating Store....Please wait!' && apiLoadingStatus === '') {
			setSnackbarSeverity('success');
			setSnackbarMessage(`${selectedStoreName} has been successfully activated.`);
			setOpenSnackbar(false);
		}
		if (prevApiLoadingStatus.current === 'Fetching Store Status....Please wait!' && apiLoadingStatus === '') {			
			showSnackbar(snackbarMessage, snackbarSeverity);
		}
		prevApiLoadingStatus.current = apiLoadingStatus;
	}, [apiLoadingStatus]);

	const handleDetailsPanelClose = () => {
		setOpenDetailsPanel(false);
	};

	const sortData = (data, { key, direction }) => {
		const dataToSort = [...data];
		return dataToSort.sort((a, b) => {
			if (a[key] < b[key]) return direction === 'Ascending' ? -1 : 1;
			if (a[key] > b[key]) return direction === 'Ascending' ? 1 : -1;
			return 0;
		});
	};

	// Filter data based on search term
	const filteredData = wholeStoreList.filter((store) =>
		store.name.toLowerCase().includes(searchTerm.toLowerCase()) ||
		store.id.toString().toLowerCase().includes(searchTerm.toLowerCase()) ||
		store.address.fullAddress.toLowerCase().includes(searchTerm.toLowerCase())
	);

	const sortedAndFilteredData = sortData(filteredData, sortConfig);
	const indexOfLastRow = ((currentPage + 1) * rowsPerPage) > wholeStoreList.length ? wholeStoreList.length : (currentPage + 1) * rowsPerPage;
	const indexOfFirstRow = indexOfLastRow - rowsPerPage > 0 ? indexOfLastRow - rowsPerPage : 0;
	const updatedRows = sortedAndFilteredData.slice(indexOfFirstRow, indexOfLastRow);

	useEffect(() => {
		//commented code to remove request access button
		//if (sessionStorage.getItem('integration_token_otter')) {
		//	setStoresTableSubtitle(STORES_TABLE_SUBTITLE);
		//} else {
		//	setStoresTableSubtitle(STORES_TABLE_SUBTITLE_REQUEST);
		//}
		setStoresTableSubtitle(STORES_TABLE_SUBTITLE);
	}, [])

	useEffect(() => {
		//commented code to remove request access button
		//if (sessionStorage.getItem('integration_token_otter')) {
		//	setIntergrationDoesNotTokenExists(false);
		//	wholeStoreList.map((st) => {
		//	// console.log('STORE CHECK ', storeStatus.data.storeID, storeStatus?.msg);
		//		if (st.id === storeStatus.data.storeID) {
		//			if(!storeStatus?.msg){
		//			st.connected = true;
		//			} else {
		//			st.connected = false;
		//			}
		//		}
		//	});
		//	// console.log('STORE STATUS ', storeStatus, wholeStoreList);
		//	setWholeStoreList([...wholeStoreList]);
		//} else {
		//	setIntergrationDoesNotTokenExists(true);
		//}
		wholeStoreList.map((st) => {
			// console.log('STORE CHECK ', storeStatus.data.storeID, storeStatus?.msg);
				if (st.id === storeStatus.data.storeID) {
					if(!storeStatus?.msg){
					st.connected = true;
					} else {
					st.connected = false;
					}
				}
			});
	}, [storeStatus]);

	useEffect(()=> {
		//commented code to remove request access button
		//let integrationToken = sessionStorage.getItem('integration_token_otter');
		//if (integrationToken) {
		//	storeListData?.items.map((stores) => {
		//	dispatch(getStoreConnection({ integrationToken, brandID, storeID: stores['id'] }));
		//	});
		//}
		storeListData?.items.map((stores) => {
			dispatch(getStoreConnection({ integrationToken, brandID, storeID: stores['id'] }));
		});
	},[storeConnection])

	useEffect(() => {
		// console.log('STORES ',storeListData)
		if (storeListData && storeListData?.items) {
			//setBrandList(storeListData?.items);
			sessionStorage.removeItem('selectedBrand');
			//if (sessionStorage.getItem('integration_token_otter')) {
			//	setIntergrationDoesNotTokenExists(false);
			//	setStoreHeader(STORES_HEADERS);
			//	let integrationToken = sessionStorage.getItem('integration_token_otter');
			//	setWholeStoreList(
			//	storeListData?.items.map((st) => ({
			//		...st,
			//		'status-with-inidcation': st.connected,
			//		//'action-details': ['Details'],
			//		'action-connect': ['Deactivate|Activate'],
			//		'address.fullAddress': st.address.fullAddress
			//	}))
			//	);
			//	storeListData?.items.map((stores) => {
			//	dispatch(getStoreConnection({ integrationToken, brandID, storeID: stores['id'] }));
			//	});
			//	dispatch(updateLoadingStatus({statustext: '', status: false}))
			//} else {
				setIntergrationDoesNotTokenExists(true);
				setStoreHeader(STORES_HEADERS_ACCESS);
				let stValue = storeListData?.items.map((st) => ({
				...st,
				'status-with-inidcation': st.connected,
				//'action-details': ['Details'],
				//'action-request': ['Request Access'],
				'action-connect': ['Deactivate|Activate'],
				'address.fullAddress': st.address.fullAddress
				}))
				setWholeStoreList(stValue);
				dispatch(updateLoadingStatus({statustext: '', status: false}))
			//}
		}
	}, [storeListData]);

	useEffect(() => {
		const newTotalPages = Math.ceil(filteredData.length / rowsPerPage);
		setTotalPages(newTotalPages);
	}, [filteredData.length, rowsPerPage]);

	const onPageChange = (newPage) => {
		setCurrentPage(newPage);
	};

	const onRowsPerPageChange = (newRowsPerPage) => {
		setCurrentPage(0);
		setRowsPerPage(newRowsPerPage);
	};

	const handleStorePageSort = (columnKey) => {
		handleSortingInTable(columnKey, sortConfig, setSortConfig);
	};

	const handleStoresClick = (rowData, columnKey) => {
		//console.log('clicked', rowData, columnKey);
		setSelectedStoreName(rowData.name);
		storeID = rowData.id;
		if (columnKey.indexOf('connect') > -1) {
			//if (sessionStorage.getItem('integration_token_otter')) {
			if (sessionStorage.getItem('access_token_otter')) {
				setIntergrationDoesNotTokenExists(false);
				if (rowData['connected']) {
					showDeactivateStorePopOver(storeID);
				} else {
					showActivateStorePopOver(storeID);
				}
			//} else {
			//	setIntergrationDoesNotTokenExists(true);
			}
		} else if (columnKey.indexOf('request') > -1) {
			showIntegrationFetchPopOver();
		} else if (columnKey.indexOf('status') > -1) {
			//let integrationToken = sessionStorage.getItem('integration_token_otter');
			dispatch(getStoreConnection({ integrationToken, brandID, storeID }));
		} else {
			dispatch(merchantGetStoresDetailsOfBrand({ accessToken, brandID, storeID }));
			setOpenDetailsPanel(true);
		}
	};

	const showIntegrationFetchPopOver = () => {
		// sessionStorage.setItem('selectedBrand', JSON.stringify(selectedBrand));
		setPrimaryButtonColor('#00563C');
		setprimaryButtonText(CONTINUE);
		setlistTitle(REDIRECT_CONNECT_POPOVER.REQUEST_TO_UPDATE_STORE);
		setpopOverTitle(<p className='heading-block'>{REDIRECT_CONNECT_POPOVER.REQUEST_TO_UPDATE_STORE}</p>);
		setmerchantAccountView(
		<Grid container>
			<Grid item>{REDIRECT_CONNECT_POPOVER.CLAUSE_THREE}</Grid>
		</Grid>
		);
		setSelectedValue('Otter');
		setCurrentAction({ type: 'requestAccess' });
		setOpenConnection(true);
	};

	const showActivateStorePopOver = (storeID) => {
		setPrimaryButtonColor('#00563C');
		setprimaryButtonText(ACTIVATE);
		setlistTitle(ACTIVATION_POPOVER.ACTIVATE_TITLE);
		setpopOverTitle(<p className='heading-block'>{ACTIVATION_POPOVER.ACTIVATE_TITLE}</p>);
		setmerchantAccountView(
		<Grid container>
			<Grid item>{ACTIVATION_POPOVER.CONFIRM_ACTIVATION}</Grid>
		</Grid>
		);
		setSelectedValue('Otter');
		setCurrentAction({ type: 'activate', storeID });
		setOpenConnection(true);
	};

	const showDeactivateStorePopOver = (storeID) => {
		setprimaryButtonText(DEACTIVATE);
		setPrimaryButtonColor('#D93235');
		setlistTitle(ACTIVATION_POPOVER.DEACTIVATE_TITLE);
		setpopOverTitle(<p className='heading-block'>{ACTIVATION_POPOVER.DEACTIVATE_TITLE}</p>);
		setmerchantAccountView(
		<Grid container>
			<Grid item>{ACTIVATION_POPOVER.CONFIRM_DEACTIVATION}</Grid>
		</Grid>
		);
		setSelectedValue('Otter');
		setCurrentAction({ type: 'deactivate', storeID });
		setOpenConnection(true);
	};

	const handleClose = (value, actionType, storeID) => {
		if (value) {
			//let integrationToken = sessionStorage.getItem('integration_token_otter');
			if (actionType === 'activate') {
				dispatch(postStoreConnection({ integrationToken, brandID, storeID, accessTokenValue }));
			} else if (actionType === 'deactivate') {
				dispatch(deleteStoreConnection({ integrationToken, brandID, storeID, accessTokenValue }));
			} else if (actionType === 'requestAccess') {
				sessionStorage.setItem('selectedBrand', JSON.stringify(selectedBrand));
				window.location.href = `${process.env.OTTER_HOST_URL}/v1/auth/oauth2/authorize?client_id=${process.env.OTTER_CLIENT_ID}&redirect_uri=${process.env.OTTER_REDIRECT_URL}&response_type=code&scope=organization.service_integration&state=${process.env.OTTER_STATE_ID}`;
			}
		}
		setOpenConnection(false);
	};

	const handleBreadCrumbClick = () => {
		setContent(<OtterBrands />);
	};

	const handleRequestAccess = () => {
		showIntegrationFetchPopOver();
	}

	return (
		<>
			<div role='presentation' onClick={handleBreadCrumbClick} className='breadCrumb'>
				<Breadcrumbs aria-label='breadcrumb'>
					<Link component={RouterLink} to='' className='breadCrumb-home'>
						Brands
					</Link>
					<Typography color='text.primary' className='breadCrumb-link'>{selectedBrand.name}</Typography>
				</Breadcrumbs>
			</div>
			<div className='settings-container' data-testid='store-id'>
				<Paper className='page-header'>
					<h4 className='title' data-testid='profile-settings'>
						{selectedBrand.name}
					</h4>
					{/*{intergrationDoesNotTokenExists && 
						<button className='details-class' aria-label='Request Access' variant='outlined' onClick={handleRequestAccess}>Request Access</button>
					}*/}
				</Paper>
				<div className='store-page'>
					<div style={{ border: '1px solid #F1F1F1', backgroundColor: 'white', borderRadius: '4px' }}>
						<DataTable
						showAvatarOnStart={false}
						columns={storeHeader}
						data={updatedRows}
						tableName={STORES_TABLE_NAME}
						tableSubTitle={storesTableSubtitle}
						searchplaceholder={STORES_SEARCH_PLACEHOLDER}
						includeCheckbox={false}
						showAddToList={false}
						sortConfig={sortConfig}
						onSort={handleStorePageSort}
						clickableColumnKey='name'
						hideSearchIfOneStoreSelected={true}
						onSearch={(searchTerm) => {
							setSearchTerm(searchTerm);
							setCurrentPage(0);
						}}
						onCellClick={handleStoresClick}
						excludeColumnKey={['name']}
						sortExcludeColumns={['action-details', 'action-connect', 'action-status']}
						hideHeaders={['action-details', 'action-connect', 'action-status']}
						uncheckTheseFilters={['id']}
						//disableButtons={intergrationDoesNotTokenExists}
						/>

						<CustomPagination
						totalNumberOfPages={totalPages}
						currentPageNumber={currentPage}
						rowsPerPage={rowsPerPage}
						onPageChange={(event, newPage) => onPageChange(newPage)}
						onRowsPerPageChange={(event) => onRowsPerPageChange(parseInt(event.target.value, 10))}
						rowsPerPageOptions={[10, 20, 50]}
						/>
					</div>
				</div>
				<StoresDetailsCard open={openDetailsPanel} onClose={(value) => handleDetailsPanelClose(value)} />
				<CustomPopOver
					title={popOverTitle}
					descriptionContent={merchantAccountView}
					selectedValue={selectedValue}
					open={openConnection}
					listHeight={listHeight}
					showLowerDescription={null}
					listTitle={listTitle}
					listData={null}
					listControl={null}
					listSelectAll={true}
					primaryButton={primaryButtonText}
					primaryButtonColor={primaryButtonColor}
					onClose={(value) => handleClose(value, currentAction?.type, currentAction?.storeID, brandID)}
				/>
			</div>
			<Snackbar 
				open={openSnackbar}
				autoHideDuration={10000}
				onClose={handleSnackbarClose}
				anchorOrigin={{ vertical: 'bottom', horizontal: 'center' }}
				key={snackbarKey}
			>
				<Alert
					onClose={handleSnackbarClose}
					severity={snackbarSeverity}
					sx={{ 
						width: '100%', 
						backgroundColor: snackbarSeverity === 'success' ? '#007350' : (snackbarSeverity === 'error' ? '#000000' : ''), 
						color: '#ffffff'
					}}
				>
					{snackbarMessage}
				</Alert>
			</Snackbar>
		</>
	);
}

export default OtterStores;
